export default __webpack_public_path__ + "static/media/carousel8Mobile.aa08b399.jpg";